<template>
  <div :class="[
      $style['buttonGroup-' + topSpacing],
      $style['align-' + direction],
      $style['spaceBetween-' + spaceBetween]
      ]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "button-group",
  props: {
    topSpacing: {
      type: String,
      required: false,
      default: "xs",
      validator: function (value) {
        return ["xs", "s", "m", "l", "xl"].indexOf(value) !== -1;
      }
    },
    spaceBetween: {
      type: String,
      required: false,
      default: "xs",
      validator: function (value) {
        return ["none", "xs", "s", "m", "l", "xl"].indexOf(value) !== -1;
      }
    },
    direction: {
      type: String,
      required: false,
      default: "left",
      validator: function (value) {
        return ["left", "right"].indexOf(value) !== -1;
      }
    },
  }
};
</script>

<style module lang="scss">
@import "../../style/abstract/abstract.functions";
@import "../../style/abstract/abstract.spacing";

$sizes: (
    "xs": $spacing-xs,
    "s": $spacing-s,
    "m": $spacing-m,
    "l": $spacing-l,
    "xl": $spacing-xl
);

.buttonGroup {
  margin-top: rem-calc($spacing-xl);
  display: flex;
  justify-content: flex-start;
}

@each $size, $spacing in $sizes {
  .buttonGroup-#{$size} {
    composes: buttonGroup;
    margin-top: $spacing
  }

  .spaceBetween-#{$size} > * {
    margin-right: rem-calc($spacing);
  }
}

.align-right {
  justify-content: flex-end;

  @each $size, $spacing in $sizes {
    &.spaceBetween-#{$size} > * {
      margin-right: 0; // Reset
      margin-left: rem-calc($spacing);
    }
  }
}
</style>
